'use strict';

angular.module('internal.investigations')
    .directive('internalInvestigationActions', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'investigations/components/investigation-actions/investigation-actions.html',
            replace: true,
            controller: 'InternalActions'
        };
    }])
;